/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./scripts/react/common/helpers/helpers.js":
/*!*************************************************!*\
  !*** ./scripts/react/common/helpers/helpers.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"getWindowVariable\": () => (/* binding */ getWindowVariable),\n/* harmony export */   \"safeRender\": () => (/* binding */ safeRender)\n/* harmony export */ });\n/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react-dom */ \"./node_modules/react-dom/index.js\");\n/* harmony import */ var has__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! has */ \"./node_modules/has/src/index.js\");\n/* harmony import */ var has__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(has__WEBPACK_IMPORTED_MODULE_1__);\n\n\n\nfunction getWindowVariable(key, callback = null) {\n  if (!has__WEBPACK_IMPORTED_MODULE_1___default()(window, key)) {\n    return undefined;\n  }\n\n  return callback ? callback(window[key]) : window[key];\n}\n\nfunction safeRender(component, root) {\n  if (!root) {\n    return;\n  }\n\n  try {\n    (0,react_dom__WEBPACK_IMPORTED_MODULE_0__.render)(component, root);\n  } catch {\n    console.error(\"Failed to render a component\");\n  }\n}\n\n\n\n//# sourceURL=webpack://spotview-shopify-theme/./scripts/react/common/helpers/helpers.js?");

/***/ }),

/***/ "./scripts/react/menu-blog/components/MenuBlog.js":
/*!********************************************************!*\
  !*** ./scripts/react/menu-blog/components/MenuBlog.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (/* binding */ MenuBlog)\n/* harmony export */ });\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"./node_modules/react/index.js\");\n/* harmony import */ var _MenuBlogItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./MenuBlogItem */ \"./scripts/react/menu-blog/components/MenuBlogItem.js\");\n\n\nfunction MenuBlog({\n  id\n}) {\n  const selectedTag = id?.split(\" \")?.[1];\n\n  const tagToHandleize = tag => {\n    return tag?.toLowerCase().replace(/\\s/g, \"-\");\n  };\n\n  const [articles, setArticles] = react__WEBPACK_IMPORTED_MODULE_0__.useState([]);\n  const query = `{\n    blog(id: \"gid:\\/\\/shopify\\/Blog\\/86988947650\") {\n        title\n        articles (first: 250) {\n            nodes {\n                id\n                title\n                handle\n                image {\n                    src\n                }\n                tags\n            }\n        }\n    }\n  }`;\n  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {\n    fetch(`https://sidisportsrl.myshopify.com/api/2024-04/graphql.json`, {\n      method: \"POST\",\n      headers: {\n        \"X-Shopify-Storefront-Access-Token\": \"0a86c0dc38503bc89ab9ef42ed2d10c1\",\n        \"Content-Type\": \"application/graphql\",\n        Accept: \"application/json\"\n      },\n      body: query\n    }).then(response => response.json()).then(data => {\n      var articles = [];\n\n      for (let i = 0; i < data?.data?.blog?.articles?.nodes?.filter(n => tagToHandleize(n.tags?.[0]) === tagToHandleize(selectedTag)).length; i++) {\n        var article = data?.data?.blog?.articles?.nodes[i];\n        if (articles.length == 2) break;\n        articles.push({\n          id: article?.id,\n          handle: article?.handle,\n          image: article?.image?.src,\n          title: article?.title,\n          tag: article?.tags?.[0]\n        });\n      }\n\n      setArticles(articles);\n    }).catch(error => console.log(error));\n  }, []);\n  return articles?.map(article => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_MenuBlogItem__WEBPACK_IMPORTED_MODULE_1__[\"default\"], {\n    article: article,\n    key: article.id\n  }));\n}\n\n//# sourceURL=webpack://spotview-shopify-theme/./scripts/react/menu-blog/components/MenuBlog.js?");

/***/ }),

/***/ "./scripts/react/menu-blog/components/MenuBlogItem.js":
/*!************************************************************!*\
  !*** ./scripts/react/menu-blog/components/MenuBlogItem.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (/* binding */ MenuBlogItem)\n/* harmony export */ });\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"./node_modules/react/index.js\");\n\nfunction MenuBlogItem({\n  article\n}) {\n  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"li\", {\n    key: article.id\n  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"div\", {\n    className: \"header__submenu_blog\"\n  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"img\", {\n    src: article.image,\n    width: \"455\",\n    height: \"200\",\n    alt: article.title,\n    className: \"header__submenu_blog_image\",\n    loading: \"lazy\"\n  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"div\", {\n    className: \"header__submenu_blog_item_tag_container\"\n  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"span\", {\n    className: \"header__submenu_blog_item_tag\"\n  }, article.tag)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"div\", {\n    className: \"header__submenu_blog_item_info\"\n  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"a\", {\n    id: `HeaderMenu-${article.handle}`,\n    href: `/news/${article.handle}`,\n    className: \"header__submenu_blog_title link--text focus-inset\"\n  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"span\", null, \" \", article.title, \" \")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"div\", {\n    className: \"header__submenu_third_level_blog_all\"\n  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"a\", {\n    id: `HeaderMenu-${article.handle}`,\n    href: article.handle,\n    className: \"header__submenu_third_level_label\"\n  }, \"Read more\"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"svg\", {\n    xmlns: \"http://www.w3.org/2000/svg\",\n    width: \"37\",\n    height: \"14\",\n    viewBox: \"0 0 37 14\",\n    fill: \"none\",\n    className: \"icon_right\"\n  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(\"path\", {\n    d: \"M1 6.74219C1 6.74219 15.6274 6.74219 25 6.74219M25 6.74219C22.4616 4.39904 21.0384 3.08533 18.5 0.742188M25 6.74219C22.4616 9.08533 21.0384 10.399 18.5 12.7422\",\n    stroke: \"#202020\",\n    strokeWidth: \"1.5\",\n    strokeLinecap: \"round\"\n  }))))));\n}\n\n//# sourceURL=webpack://spotview-shopify-theme/./scripts/react/menu-blog/components/MenuBlogItem.js?");

/***/ }),

/***/ "./scripts/react/menu-blog/menu-blog.js":
/*!**********************************************!*\
  !*** ./scripts/react/menu-blog/menu-blog.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"./node_modules/react/index.js\");\n/* harmony import */ var scripts_react_common_helpers_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! scripts/react/common/helpers/helpers */ \"./scripts/react/common/helpers/helpers.js\");\n/* harmony import */ var scripts_react_menu_blog_components_MenuBlog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! scripts/react/menu-blog/components/MenuBlog */ \"./scripts/react/menu-blog/components/MenuBlog.js\");\n// @ts-nocheck\n\n\n\nconst menuBlogWrapper = document.getElementsByClassName(\"header__submenu_blog_wrapper\");\n\nfor (let i = 0; i < menuBlogWrapper.length - 1; i++) {\n  (0,scripts_react_common_helpers_helpers__WEBPACK_IMPORTED_MODULE_1__.safeRender)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(scripts_react_menu_blog_components_MenuBlog__WEBPACK_IMPORTED_MODULE_2__[\"default\"], {\n    id: menuBlogWrapper[i].id\n  }), menuBlogWrapper[i]);\n}\n\n//# sourceURL=webpack://spotview-shopify-theme/./scripts/react/menu-blog/menu-blog.js?");

/***/ }),

/***/ "./scripts/theme.js":
/*!**************************!*\
  !*** ./scripts/theme.js ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_theme_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../styles/theme.scss */ \"./styles/theme.scss\");\n/* harmony import */ var _react_menu_blog_menu_blog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./react/menu-blog/menu-blog */ \"./scripts/react/menu-blog/menu-blog.js\");\n\n\n/*import 'scripts/utils.js'\n\nimport 'scripts/state.js'\n\nimport './react/header/section' \nimport './react/menu/section'\nimport './react/slider-fullscreen/section'\nimport './react/category-three-col/section'\nimport 'scripts/react/minicart/section'\nimport 'scripts/react/product-details/section'\nimport 'scripts/react/accordion/section'\nimport 'scripts/react/product-listing/section'\nimport 'scripts/react/featured-product/section'\nimport 'assets/facets'*/\n\n//# sourceURL=webpack://spotview-shopify-theme/./scripts/theme.js?");

/***/ }),

/***/ "./styles/theme.scss":
/*!***************************!*\
  !*** ./styles/theme.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://spotview-shopify-theme/./styles/theme.scss?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"theme": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkspotview_shopify_theme"] = self["webpackChunkspotview_shopify_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_has_src_index_js-node_modules_react-dom_index_js"], () => (__webpack_require__("./scripts/theme.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;